export const centralComplaintsConstants = {
    FETCH_COMPLAINTS_DATA_REQUESTING: "FETCH_COMPLAINTS_DATA_REQUESTING",
    CENTRAL_COMPLAINTS_DATA_FETCHED: "CENTRAL_COMPLAINTS_DATA_FETCHED",
    COMPLAINTS_DATA_FAILED: "COMPLAINTS_DATA_FAILED",
  };
  